import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {Link, RouteComponentProps} from 'react-router-dom';
import {Button, ButtonGroup, Col, Label, Row} from 'reactstrap';
import {AvField, AvForm, AvGroup, AvInput} from 'availity-reactstrap-validation';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {IRootState} from 'app/shared/reducers';
import {createEntity, getEntity, reset, updateEntity} from './incident-report.reducer';
import {hasAnyPermission} from "app/shared/auth/permissions";
import {getAllByType as getCountries} from "app/entities/region/region.reducer";

export interface IIncidentReportUpdateProps extends StateProps, DispatchProps, RouteComponentProps<{ id: string }> {
}

export const IncidentReportUpdate = (props: IIncidentReportUpdateProps) => {
  const {countries, isAdmin, userCountryId, incidentReportEntity, loading, updating} = props;
  const [isNew, setIsNew] = useState(!props.match.params || !props.match.params.id);
  const [countryId, setCountryId] = useState(null)
  const [activeStatus, setActiveStatus] = useState(true);

  const handleClose = () => {
    props.history.push('/incident-report');
  };

  useEffect(() => {
    if(!countries || countries.length === 0) {
      props.getCountries();
    }
  }, []);

  useEffect(() => {
    if (countries && countries.length > 0) {
      const ac = countries.find(country => country.id === userCountryId)
      const params = new URLSearchParams(props.location.search);
      setCountryId(isAdmin ? params.get('country_id') : ac.id)
    }
  }, [countries, userCountryId]);

  useEffect(() => {
    if (isNew) {
      props.reset();
    } else {
      props.getEntity(props.match.params.id);
    }
  }, []);

  useEffect(() => {
    const incidentReportStatus = incidentReportEntity?.isActive
    setActiveStatus(incidentReportStatus)
  }, [incidentReportEntity]);


  useEffect(() => {
    if (props.updateSuccess) {
      handleClose();
    }
  }, [props.updateSuccess]);

  const saveEntity = (event, errors, values) => {
    if (errors.length === 0) {
      const cid = isNew ? countryId : incidentReportEntity.countryId;
      const country = props.countries.find(c => c.id === cid)
      const entity = {
        ...incidentReportEntity,
        ...values,
        isActive: activeStatus,
        // country
      };

      if (isNew) {
        props.createEntity(entity);
      } else {
        props.updateEntity(entity);
      }
    }
  };

  const regCountriesList = countries.filter((ele)=>{
    return  isAdmin ? 1  : ele.id === countryId;
  })

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="mmamaApp.incidentReport.home.createOrEditLabel">Create or edit an Incident Report</h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <AvForm model={isNew ? {} : incidentReportEntity} onSubmit={saveEntity}>
              {!isNew ? (
                <AvGroup>
                  <Label for="incident-report-id">ID</Label>
                  <AvInput id="incident-report-id" type="text" className="form-control" name="id" required readOnly/>
                </AvGroup>
              ) : null}
              <AvGroup>
                <Label id="lastNameLabel" for="driver-lastName">
                  Active Status
                </Label>
                <ButtonGroup style={{marginLeft: "30px"}}>

                  <Button
                    color={activeStatus ? 'primary' : 'secondary'}
                    value={activeStatus}
                    onClick={(e) => {
                      setActiveStatus(true)
                    }}
                  >
                    Active
                  </Button>


                  <Button
                    color={!activeStatus ? 'primary' : 'secondary'}
                    value={activeStatus}
                    onClick={() => {
                      setActiveStatus(false)
                    }}
                  >
                    Inactive
                  </Button>

                </ButtonGroup>
              </AvGroup>
              <AvGroup>
                <Label id="descriptionLabel" for="incident-report-description">
                  Description
                </Label>
                <AvField
                  id="incident-report-description"
                  type="text"
                  name="description"
                  validate={{
                    required: {value: true, errorMessage: 'This field is required.'},
                  }}
                />
              </AvGroup>

              <AvGroup>
                <Label id="enConditionLabel" for="incident-enCondition">
                  Incident Report (English)
                </Label>
                <AvField
                  id="incident-enCondition"
                  type="text"
                  name="enIncident"
                  validate={{
                    required: {value: true, errorMessage: 'This field is required.'},
                  }}
                />
              </AvGroup>
              <AvGroup>
                <Label id="stConditionLabel" for="incident-stCondition">
                  Incident Report (Local Language)
                </Label>
                <AvField
                  id="incident-stCondition"
                  type="text"
                  name="stIncident"
                  validate={{
                    required: {value: true, errorMessage: 'This field is required.'},
                  }}
                />
              </AvGroup>

              <AvGroup>
                <Label id="displayOrderLabel" for="incident-displayOrder">
                  Display Order
                </Label>
                <AvField
                  id="incident-displayOrder"
                  type="number"
                  name="displayOrder"
                  validate={{
                    required: {value: true, errorMessage: 'This field is required.'},
                  }}
                />
              </AvGroup>

              {regCountriesList && regCountriesList.length > 0 && (
                <AvGroup>
                  <Label for="incident-country">Country</Label>
                  <AvInput id="incident-country" type="select" className="form-control" name="countryId"
                           value={isNew ? countryId : incidentReportEntity.countryId} readOnly={!isNew}
                           disabled={!isNew}>
                    {regCountriesList
                      ? regCountriesList.map(country => (
                        <option value={country.id} key={country.id}>
                          {country.name}
                        </option>
                      ))
                      : null}
                  </AvInput>
                </AvGroup>
              )

              }

              <Button tag={Link} id="cancel-save" to="/incident-report" replace color="info">
                <FontAwesomeIcon icon="arrow-left"/>
                &nbsp;
                <span className="d-none d-md-inline">Back</span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save"/>
                &nbsp; Save
              </Button>
            </AvForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

const mapStateToProps = (storeState: IRootState) => ({
  incidentReportEntity: storeState.incidentReport.entity,
  loading: storeState.incidentReport.loading,
  updating: storeState.incidentReport.updating,
  updateSuccess: storeState.incidentReport.updateSuccess,
  countries: storeState.region.countries,
  userCountryId: storeState.authentication.userCountryId,
  isAdmin: hasAnyPermission(storeState.authentication.account.roles, ['ADMIN'])
});

const mapDispatchToProps = {
  getEntity,
  updateEntity,
  createEntity,
  reset,
  getCountries,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(IncidentReportUpdate);
